import { Controller } from '@hotwired/stimulus'

const UPDATE_DELAY_MS = 200

export default class NotificationCountController extends Controller {
  connect () {
    this.handleBeforeStreamRender = this.beforeStreamRender.bind(this)
    this.handleBeforeCache = this.flushPendingRender.bind(this)
    document.addEventListener(
      'turbo:before-stream-render',
      this.handleBeforeStreamRender
    )
    document.addEventListener('turbo:before-cache', this.handleBeforeCache)
  }

  disconnect () {
    clearTimeout(this.renderTimer)
    document.removeEventListener(
      'turbo:before-stream-render',
      this.handleBeforeStreamRender
    )
    document.removeEventListener('turbo:before-cache', this.handleBeforeCache)
  }

  beforeStreamRender (event) {
    const stream = event.target

    if (stream.getAttribute('target') !== this.element.id) return

    event.preventDefault()
    clearTimeout(this.renderTimer)

    const pendingStream = stream.cloneNode(true)
    const render = event.detail.render

    stream.remove()
    this.pendingStream = pendingStream
    this.pendingRender = render

    this.renderTimer = setTimeout(() => {
      this.flushPendingRender()
    }, UPDATE_DELAY_MS)
  }

  flushPendingRender () {
    if (!this.pendingStream || !this.pendingRender) return

    clearTimeout(this.renderTimer)
    const stream = this.pendingStream
    const render = this.pendingRender
    this.pendingStream = null
    this.pendingRender = null
    render(stream)
  }
}
